import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const roles = [
  {
    id: "TRADER",
    label: "Trader",
    desc: "Connect live trading accounts, get ranked, and attract capital.",
  },
  {
    id: "INVESTOR",
    label: "Investor",
    desc: "Discover and allocate to traders and analysts with verified stats.",
  },
  {
    id: "ANALYST",
    label: "Analyst",
    desc: "Publish signals and research with tracked accuracy and risk.",
  },
];

const OnboardingRole = () => {
  const [selected, setSelected] = useState("TRADER");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submitRole = async () => {
    setBusy(true);
    setError("");
    try {
      // TODO: in the next step we will call /api/user/apply-role.
      console.log("APPLY ROLE (dummy)", selected);

      if (selected === "INVESTOR") navigate("/investor");
      else if (selected === "ANALYST") navigate("/analyst");
      else navigate("/trader");
    } catch (err) {
      setError(err.message || "Failed to apply role");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Select your primary role</h2>
        <p className="muted">
          This helps us route you to the right dashboard and features.
        </p>

        {error && <div className="auth-error">{error}</div>}

        <div className="role-grid">
          {roles.map((r) => (
            <button
              type="button"
              key={r.id}
              className={
                "role-card" + (selected === r.id ? " role-card-active" : "")
              }
              onClick={() => setSelected(r.id)}
            >
              <div className="role-title">{r.label}</div>
              <div className="role-desc">{r.desc}</div>
            </button>
          ))}
        </div>

        <button
          onClick={submitRole}
          disabled={busy}
          className="auth-button"
          style={{ marginTop: 18 }}
        >
          {busy ? "Saving..." : "Continue to dashboard"}
        </button>
      </div>
    </div>
  );
};

export default OnboardingRole;
